var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilemarkdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bases",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#424242;}.cls-4{fill:#dcdbdd;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_\\u77E9\\u5F62_",
    "data-name": "<\\u77E9\\u5F62>",
    className: "cls-1",
    x: 3,
    y: 8,
    width: 26,
    height: 16
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file.markdown") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u526A\\u5207\\u7EC4_",
    "data-name": "<\\u526A\\u5207\\u7EC4>"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u7F16\\u7EC4_",
    "data-name": "<\\u7F16\\u7EC4>"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "9 20.24 9 23 4 23 4 9 8.62 9 11 13.76 13.38 9 18 9 18 15.86 19 15.86 19 9 25 9 25 15.86 29.37 15.86 22.01 23.42 18 19.41 18 23 13 23 13 20.24 11 24.24 9 20.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24,10v6.86h3L22,22l-5-5v5H14V16l-3,6L8,16v6H5V10H8l3,6,3-6h3v6.86h3V10h4m2-2H12.76l-.55,1.11L11,11.53,9.79,9.11,9.24,8H3V24H9.76L11,26.47,12.24,24H19V21.83l1.59,1.59L22,24.85l1.41-1.45,5-5.14,3.3-3.39H26V8Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilemarkdown);
export default __webpack_public_path__ + "static/media/file.markdown.7ef6ad7c564b0360e1de49e30eee062b.svg";
export { ForwardRef as ReactComponent };